import React, { useEffect, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { useForm, useError } from '../../hooks'
import { useFirebaseCRUD } from '../../hooks/useFirebaseCRUD'
import DropdownField from '../Form/DropdownField'
import Button from '../Button'
import TextField from '../Form/TextField'
import ContextMenu from '../ContextMenu'
import Spinner from '../Spinner'
import { useIdGenerator } from '../../hooks/useidgenerator'

export default function () {
  const navigate = useNavigate()
  const setError = useError()
  const {
    getCollection,
    createDocument,
    loading: crudLoading
  } = useFirebaseCRUD()
  const [getFieldProps, formData, formError] = useForm()
  const { generateOrganizationId } = useIdGenerator()

  const [userTypes, setUserTypes] = useState([])
  const [timezones, setTimezones] = useState([])
  const [loading, setLoading] = useState(true)

  // ✅ Fetch userTypes and timezones from Firebase
  const fetchData = async () => {
    try {
      const fetchedUserTypes = await getCollection('userTypes')
      // const fetchedTimezones = await getCollection('timezones');

      setUserTypes(fetchedUserTypes)
      // setTimezones(fetchedTimezones);

      const tzList = Intl.supportedValuesOf('timeZone').map((tz) => ({
        id: tz,
        name: tz
      }))
      setTimezones(tzList)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  // ✅ Handle Submit (Create Organization in Firestore)
  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault()
      const { name, defaultUserTypeId, timezone } = formData

      try {
        // Firestore will auto-generate ID
        // const orgId = crypto.randomUUID(); // Or use Firestore's push() alternative if preferred
        const orgId = generateOrganizationId()

        await createDocument(`organizations/${orgId}`, {
          id: orgId,
          name,
          defaultUserTypeId,
          timezone: timezone || 'America/Chicago',
          createdAt: new Date().toISOString()
        })

        navigate(`/organizations/${orgId}`)
      } catch (err) {
        if (err.message === 'validation_error') {
          formError(err.props)
        } else {
          setError(err)
        }
      }
    },
    [
      formData,
      createDocument,
      navigate,
      formError,
      setError,
      generateOrganizationId
    ]
  )

  if (loading || crudLoading) {
    return <Spinner />
  }

  return (
    <div className='box'>
      <form onSubmit={handleSubmit}>
        <TextField
          label='Name'
          name='name'
          placeholder='Name'
          required={true}
          {...getFieldProps()}
        />

        <DropdownField
          name='defaultUserTypeId'
          label='Default User Type'
          required={true}
          {...getFieldProps()}>
          <option />
          {userTypes.map((userType) => (
            <option key={userType.id} value={userType.id}>
              {userType.name}
            </option>
          ))}
        </DropdownField>

        <DropdownField
          name='timezone'
          label='Time Zone'
          defaultValue='America/Chicago'
          required={true}
          {...getFieldProps()}>
          {timezones.map((tz) => (
            <option key={tz.id} value={tz.name}>
              {tz.name}
            </option>
          ))}
        </DropdownField>

        <div className='flex justify-end'>
          <Button type='submit'>Create</Button>
        </div>
      </form>
    </div>
  )
}
